import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import VerifyEmailOtp from "@/pages/VerifyEmailOtp";
import Dashboard from "@/pages/Dashboard";
import Verify from "@/pages/Verify";
import Offers from "@/pages/Offers";
import OfferDetail from "@/pages/OfferDetail";
import StudentCard from "@/pages/StudentCard";
import SavedOffers from "@/pages/SavedOffers";
import MyCoupons from "@/pages/MyCoupons";
import Outlets from "@/pages/Outlets";
import OutletDetail from "@/pages/OutletDetail";
import Scan from "@/pages/Scan";
import AdminPortal from "@/pages/AdminPortal";
import PublicStudentPass from "@/pages/PublicStudentPass";
import LegalPage from "@/pages/LegalPage";
import PartnerWithUs from "@/pages/PartnerWithUs";
import Support from "@/pages/Support";
import Account from "@/pages/Account";
import FreshersReward from "@/pages/FreshersReward";
import EventStaffScan from "@/pages/EventStaffScan";
import DeleteAccount from "@/pages/DeleteAccount";
import CookieConsent from "@/components/CookieConsent";
import { AnnouncementProvider } from "@/context/AnnouncementsContext";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AnnouncementProvider>
          <Toaster theme="dark" position="top-center" richColors closeButton />
          <CookieConsent />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/verify-email" element={<VerifyEmailOtp />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/offers/:id" element={<OfferDetail />} />
            <Route path="/outlets" element={<Outlets />} />
            <Route path="/outlets/:id" element={<OutletDetail />} />
            <Route path="/verify-pass" element={<PublicStudentPass />} />
            <Route path="/terms" element={<LegalPage />} />
            <Route path="/privacy" element={<LegalPage />} />
            <Route path="/cookies" element={<LegalPage />} />
            <Route path="/partner-with-us" element={<PartnerWithUs />} />
            <Route path="/support" element={<Support />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/scan" element={<ProtectedRoute requirePartner><Scan /></ProtectedRoute>} />
            <Route path="/event-staff/scan" element={<ProtectedRoute requireEventStaff><EventStaffScan /></ProtectedRoute>} />
            <Route path="/freshers-reward" element={<ProtectedRoute><FreshersReward /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/verify" element={<ProtectedRoute><Verify /></ProtectedRoute>} />
            <Route path="/card" element={<ProtectedRoute><StudentCard /></ProtectedRoute>} />
            <Route path="/saved" element={<ProtectedRoute><SavedOffers /></ProtectedRoute>} />
            <Route path="/coupons" element={<ProtectedRoute><MyCoupons /></ProtectedRoute>} />
            <Route path="/admin/*" element={<ProtectedRoute requireAdmin><AdminPortal /></ProtectedRoute>} />
          </Routes>
        </AnnouncementProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
